import {ConsentCookieIsAlreadySetEvent} from "../../../../common/ts/events/Events";
import CookieService from "../../../../common/ts/services/CookieService";
import {CONSENT_COOKIE_NAME} from "../../../../common/ts/components/core/ConsentCookie";
import {EventBus} from "../../../../common/ts/events/EventBus";

export const TROVIT_PERSONALIZED_GOOGLE_ADS = "trovit_personalized_google_ads";

export class CookieDisclaimer {
    private readonly cookieDisclaimer: HTMLElement | null;
    private readonly acceptCookieDisclaimerButton: HTMLElement | null;
    private readonly denyCookieDisclaimerButton: HTMLElement | null;
    private cookieService: CookieService;
    private eventBus: EventBus;

    constructor() {
        this.cookieDisclaimer = document.querySelector('#cookie-disclaimer');
        this.acceptCookieDisclaimerButton = document.querySelector('#accept-cookie-disclaimer-button');
        this.denyCookieDisclaimerButton = document.querySelector('#deny-cookie-disclaimer-button');
        this.cookieService = new CookieService();
        this.eventBus = EventBus.getInstance();
    }

    init() {
        if (!this.cookieService.getCookie(CONSENT_COOKIE_NAME) && this.cookieDisclaimer) {
            this.registerEvents();
        }
    }

    private hideCookieDisclaimer() {
        this.cookieDisclaimer!.style.display = 'none';
    }

    private registerEvents() {
        this.registerAcceptClickEvent();
        this.registerDenyClickEvent();
    }

    private registerAcceptClickEvent() {
        if (this.acceptCookieDisclaimerButton) {
            this.acceptCookieDisclaimerButton.addEventListener('click', () => this.handleCookieDisclaimerButtonClick('1'));
        }
    }

    private registerDenyClickEvent() {
        if (this.denyCookieDisclaimerButton) {
            this.denyCookieDisclaimerButton.addEventListener('click', () => this.handleCookieDisclaimerButtonClick('0'));
        }
    }

    private handleCookieDisclaimerButtonClick(acceptCookieDisclaimer: string) {
        this.setCookies(acceptCookieDisclaimer);
        this.eventBus.emit(new ConsentCookieIsAlreadySetEvent());
        this.hideCookieDisclaimer();
    }

    private setCookies(acceptCookieDisclaimer: string) {
        this.cookieService.setExpirableCookie(CONSENT_COOKIE_NAME, '0', 365);
        this.cookieService.setExpirableCookie(TROVIT_PERSONALIZED_GOOGLE_ADS, acceptCookieDisclaimer, 365);
    }
}

window.cookieDisclaimer = null;
window.addEventListener('load', function () {
    if (!window.cookieDisclaimer) {
        window.cookieDisclaimer = new CookieDisclaimer();
        window.cookieDisclaimer.init();
    }
});

declare global {
    interface Window {
        cookieDisclaimer: CookieDisclaimer | null;
    }
}
